export default __webpack_public_path__ + "locales/ar-SA/DeleteProfileEverDialog.json?hash=8556fa44d1f1f7049ee279fb834057d2";